import React from "react";
import { styled } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

export const VSTableCellStyled = styled(TableCell)(({theme, ...props}) => ({
  head: {
    backgroundColor: "#2c3a48",
    color: theme.palette.common.white,
    padding: "10px 20px !important",
    fontSize: "16px",
    fontWeight: "500 !important",
    fontFamily: "Inter",
    borderBottom: "none",
    [theme.breakpoints.down('sm')]: {
      fontSize: "10px !important",
    },
  },
  body: {
    fontSize: 12,
    fontFamily: "Inter",
    [theme.breakpoints.down('sm')]: {
      fontSize: "8px !important",
    },
  },
  root: {
    width: props.width,
    maxHeight: "38px",
    borderBottom: "none",
    padding: "10px 12px 10px 20px",
    [theme.breakpoints.down('md')]: {
      padding: "6px !important",
    },
    [theme.breakpoints.down('sm')]: {
      padding: "6px 2px !important",
    },
    fontWeight: "200",
    color: theme.palette.common.white,
    "&:hover": {
      borderBottom: "none",
    },
  },
}));

export const VSTableHeaderCellStyled = styled(TableCell)(({theme}) => ({
  backgroundColor: "#2c3a48",
  color: "white",
  fontSize: "12px",
  padding: "8px",
}))

export const VSTableBodyCellStyled = (props) => {
  return (
  <TableCell {...props} sx={(theme) => ({
    ...props?.sx,
    opacity: props.isDisabled ? 0.5 : 1,
    "& input[type='checkbox']": {
      border: props.isDisabled ? "0.15em solid #ffffff" : "0.15em solid #19b2ab",
    }, 
    fontSize: 12,
    fontFamily: "Inter",
    color: theme.palette.common.white,
    backgroundColor: props?.selected ? "rgba(25, 178, 171, 0.2)" : "none",
    borderBottom: "solid 1px #ffffff4c",
    [theme.breakpoints.down('md')]: {
      padding: "8px",
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: "8px !important",
    },
  })
  }/>
)}

export const VSTableCellStyledForFunction = styled(TableCell)(({theme}) => ({
  head: {
    backgroundColor: "#2c3a48",
    color: theme.palette.common.white,
    padding: "5px 0px !important",
    fontSize: "16px",
    fontWeight: "500 !important",
    fontFamily: "Inter",
    [theme.breakpoints.down('sm')]: {
      fontSize: "10px !important",
    },
  },
  body: {
    fontSize: 12,
    fontFamily: "Inter",
    [theme.breakpoints.down('sm')]: {
      fontSize: "8px !important",
    },
  },
  root: {
    maxHeight: "35px",
    borderBottom: "none",
    padding: "0px",
    [theme.breakpoints.down('md')]: {
      padding: "6px !important",
    },
    [theme.breakpoints.down('sm')]: {
      padding: "6px 2px !important",
    },
    fontWeight: "200",
    color: theme.palette.common.white,
    "&:hover": {
      borderBottom: "none",
    },
  },
}));

export const VSTableRowStyled = styled(TableRow)((theme) => ({
  root: {
    overflow: "hidden",
    "&:not(:last-child)": {
      borderBottom: "solid 1px rgba(255,255,255,0.1) !important",
    },
  },
}));